/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Typ média video.
 * Používá se pouze URL ze serveru bez podpory offline stavu.
 * @implements {ViewerType}
 */
class ViewerTypeVideo {
  /**
   * Vytvoří instanci.
   * @param {ViewerSourceCreator} viewerSourceCreator Poskytovatel zdroje pro zobrazení média.
   * @param {ViewerControllerVideoFactory} controllerFactory Továrna na vytváření nových ovladačů videa.
   * @returns {ViewerTypeVideo} Nová instance.
   */
  constructor(viewerSourceCreator, controllerFactory) {
    this.viewerSourceCreator = viewerSourceCreator;
    this.controllerFactory = controllerFactory;
  }

  /** @inheritdoc */
  createController() {
    return this.controllerFactory.create();
  }

  /** @inheritdoc */
  getCheckFile(medium) {
    // Videa mají v detailu média nastavení "Kontrolovat aktuální verzi".
    // Hodnota se předává v parametrech média.
    return medium.params?.checkFile ?? false;
  }

  /** @inheritdoc */
  getSourceCreator() {
    return this.viewerSourceCreator;
  }

  /** @inheritdoc */
  getUrl(medium) {
    return new Promise((resolve) => resolve(medium.url ?? undefined));
  }

  /** @inheritdoc */
  isExtractable() {
    return false;
  }

  /** @inheritdoc */
  isOfflineable() {
    return false;
  }

  /** @inheritdoc */
  isPreloadable(medium) {
    return true;
  }

  /** @inheritdoc */
  isSeekable(medium) {
    return true;
  }

  /** @inheritdoc */
  isStatic(medium) {
    return false;
  }
}

export default ViewerTypeVideo;
